import { useEffect } from 'react';
import useAuth from 'src/hooks/useAuth';
import { unlockAudio } from 'src/services/notifications';
import { useAbrirChatDaNotificacao, useBadgeNaoLidos } from 'src/hooks/useNotificacoes';
import NotificationPermissionBanner from './NotificationPermissionBanner';
import AlertasPendentes from './notificacoes/AlertasPendentes';

/**
 * Ponto unico de montagem do subsistema de notificacao: destrava o autoplay,
 * liga o badge da aba, escuta o clique da notificacao, mostra o banner de
 * permissao e recupera os avisos que chegaram enquanto o usuario estava fora.
 * Fica dentro do BrowserRouter para o navigate funcionar.
 */
export default function NotificationGate() {
  const { isAuthenticated } = useAuth();

  useAbrirChatDaNotificacao();
  useBadgeNaoLidos();

  // Chrome/Safari so liberam audio depois de um gesto do usuario na pagina. Sem
  // este unlock, o primeiro alerta da sessao era engolido em silencio.
  useEffect(() => {
    const destravar = () => unlockAudio();
    const opcoes = { once: true, capture: true };
    window.addEventListener('pointerdown', destravar, opcoes);
    window.addEventListener('keydown', destravar, opcoes);
    return () => {
      window.removeEventListener('pointerdown', destravar, { capture: true });
      window.removeEventListener('keydown', destravar, { capture: true });
    };
  }, []);

  if (!isAuthenticated) return null;

  // Coluna unica no canto: antes o banner era `fixed` por conta propria e a
  // pilha de avisos ocuparia exatamente o mesmo ponto, um por cima do outro.
  // Empilhados aqui, os dois convivem e o mais novo entra por baixo.
  return (
    <div className="fixed bottom-4 right-4 z-[99998] flex flex-col items-end gap-2 pointer-events-none [&>*]:pointer-events-auto">
      <NotificationPermissionBanner />
      <AlertasPendentes />
    </div>
  );
}
